import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import InventoryActions from '../Redux/InventoryRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getInventory (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getInventory, token, action.data)
      if (!res.ok) {
        yield put(InventoryActions.getInventoryFailure('GET_INVENTORY_FAILURE'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(InventoryActions.getInventorySuccess(DATA_WITH_PAGE))
        } else {
          yield put(InventoryActions.getInventoryFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(InventoryActions.getInventoryFailure())
  }
}

export function * getInventoryCustom (api, action) {
  yield baseFetchToken(
    api.getInventoryCustom,
    action.data,
    getToken,
    InventoryActions.getInventoryCustomSuccess,
    InventoryActions.getInventoryCustomFailure
  )
}

export function * createInventory (api, action) {
  yield baseFetchToken(
    api.createInventory,
    action.data,
    getToken,
    InventoryActions.createInventorySuccess,
    InventoryActions.createInventoryFailure
  )
}

export function * updateInventory (api, action) {
  yield baseFetchToken(
    api.updateInventory,
    action.data,
    getToken,
    InventoryActions.updateInventorySuccess,
    InventoryActions.updateInventoryFailure
  )
}

export function * updateInventoryImage (api, action) {
  yield baseFetchToken(
    api.updateInventoryImage,
    action.data,
    getToken,
    InventoryActions.updateInventoryImageSuccess,
    InventoryActions.updateInventoryImageFailure
  )
}

export function * deleteInventory (api, action) {
  yield baseFetchToken(
    api.deleteInventory,
    action.data,
    getToken,
    InventoryActions.deleteInventorySuccess,
    InventoryActions.deleteInventoryFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/InventorySagas.js